import gql from 'graphql-tag';

export default gql`
subscription {
    onCreateEtlQuery {
        __typename
        id
    }
}`;


// WEBPACK FOOTER //
// ./src/GraphQueries/EtlQueries/NewSubscription.js